module.exports = __webpack_public_path__ + "9c036caf74082eb3addb5d45801f3b8f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/GroupInviteModal/mobile_join_pdf.png
// module id = 1335
// module chunks = 4